export default __webpack_public_path__ + "static/blob6-520bd06801d9b37c142c020eec00c597.svg";